export default {
  upcoming: 'upcoming',
  paid: 'paid',
  failed: 'failed',
};
